export enum Tags {
  USER = "USER",
  USER_PHOTO = "USER_PHOTO",
  GROUPS = "GROUPS",
  ONE_GROUP = "ONE_GROUP",
  STORE = "STORE",
  JUSTIFICATION = "JUSTIFICATION",
  ACCOUNTING_ACCOUNT = "ACCOUNTING_ACCOUNT",
  ACCOUNTING_ACCOUNT_ACTIVE = "ACCOUNTING_ACCOUNT_ACTIVE",
  CAN_CLOSE_CONCILIATION = "CAN_CLOSE_CONCILIATION",
  OPTIONS_STORE = "STORES_OPTIONS",
  OPTIONS_RESPONSIBLE = "STORE_RESPONSIBLES_OPTIONS",
  OPTIONS_REGIONAL = "STORES_REGIONAL_OPTIONS",
  JUSTIFICATION_ACTIVE = "JUSTIFICATION_ACTIVE",
  DIVERGENCE = "DIVERGENCE",
  FILE = "FILE",
  STORE_CONCILIATION = "STORE_CONCILIATION",
  SPED_FILE = "SPED_FILE",
  TRANSACTION_BY_DATE = "TRANSACTION_BY_DATE",
  NSU = "NSU",
  LATE_TRANSACTIONS = "LATE_TRANSACTIONS",
  LACK_TRANSACTIONS = "LACK_TRANSACTIONS",
  ANALYST_ASSIGNMENT = "ANALYST_ASSIGNMENT",
  REGIONAL = "REGIONAL",
  TAX_INTEGRATION = "TAX_INTEGRATION",
  ALL_USERS = "ALL_USERS",
  TREASURY = "TREASURY",
  ONE_USER = "ONE_USER",
  ACCESS_REQUEST = "ACCESS_REQUEST",
  UNLOCK_ELIGIBLE = "UNLOCK_ELIGIBLE",
  FIND_USER_IN_LOGIX = "FIND_USER_IN_LOGIX",
  TRANSACTION_REVERSAL = "TRANSACTION_REVERSAL",
  CONCILIATION_REPORT = "CONCILIATION_REPORT",
  METABASE = "METABASE",
  CASH_BALANCE_REPORT = "CASH_BALANCE_REPORT",
  TERMS = "TERMS",
  TERM_VALIDATION = "TERM_VALIDATION",
  NCM = "NCM",
  QUERY_UPDATE = "QUERY_UPDATE",
  QUERY_FAVORITES = "QUERY_FAVORITES",
  QUERY_RULES = "QUERY_RULES",
  QUERY_CONNECTIONS = "QUERY_CONNECTIONS",
  CASH_BALANCE = "CASH_BALANCE",
  TAX_HISTORY = "TAX_HISTORY",
  SUPPLIER = "SUPPLIER",
  ENGINE_FISCAL_RULES = "ENGINE_FISCAL_RULES",
  EXCEPTION_LIST = "EXCEPTION_LIST",
  ENGINE_HISTORY = "ENGINE_HISTORY",
  DTEF = "DTEF",
  STORE_EMAIL = "STORE_EMAIL",
  EMAIL_REPORT = "EMAIL_REPORT",
  OPTIONS_NCM = "OPTIONS_NCM",
  TAX_DASHBOARD = "TAX_DASHBOARD",
  TAX_WORKFLOW = "TAX_WORKFLOW",
  OPTIONS_OFM_STORE = "OPTIONS_OFM_STORE",
  OFM_EXTRACT = "OFM_EXTRACT",
  OFM_LIST_SCHEDULER = "OFM_LIST_SCHEDULER",
  OFM_LIST_JOBS = "OFM_LIST_JOBS",
  OFM_CREATE_EXTRACT = "OFM_CREATE_EXTRACT",
  SPED_DEVOLUTION = "SPED_DEVOLUTION",
  CAMPAIGNS = "CAMPAIGNS",
  CAMPAIGN = "CAMPAIGN",
  COMPARISON = "COMPARISON",
  PROPAGATION = "PROPAGATION",
  PDF_EXTRACTOR_ICMS = "PDF_EXTRACTOR_ICMS",
  CONCILIACAO_FISCAL = "CONCILIACAO_FISCAL",
  ASYNC_JOB = "ASYNC_JOB",
  CAMPAIGN_ROULETTE = "CAMPAIGN_ROULETTE",
  GAMIFICATION = "GAMIFICATION",
  GAMIFICATION_SETTINGS = "GAMIFICATION_SETTINGS",
  JOB_PROGRESS = "JOB_PROGRESS",
  STORE_OPERATORS_ACCESS = "STORE_OPERATORS_ACCESS",
  STORE_USERS_ACCESS = "STORE_USERS_ACCESS",
  CONCILIATION_STATUS_GRID = "CONCILIATION_STATUS_GRID",
  GROUP_AUDIT = "GROUP_AUDIT",
  DEPOSIT_STORES_SUMMARY = "DEPOSIT_STORES_SUMMARY",
  DEPOSIT_ITEMS = "DEPOSIT_ITEMS",
  DEPOSIT_DRAFTS = "DEPOSIT_DRAFTS",
  DEPOSIT_BATCHES = "DEPOSIT_BATCHES",
  TAX_RECONCILIATION = "TAX_RECONCILIATION",
  TAX_RECONCILIATION_JOB = "TAX_RECONCILIATION_JOB",
  CAV_OFFLINE_SYNC = "CAV_OFFLINE_SYNC",
  TAX_CLOSING = "TAX_CLOSING",
  TAX_CLOSING_ACTIVE = "TAX_CLOSING_ACTIVE",
  TAX_CLOSING_STATUS = "TAX_CLOSING_STATUS",
  TAX_CLOSING_HISTORY = "TAX_CLOSING_HISTORY",
  TAX_CLOSING_PERIOD = "TAX_CLOSING_PERIOD",
  TAX_CLOSING_REPROCESS = "TAX_CLOSING_REPROCESS",
  STORE_BANK_ACCOUNT = "STORE_BANK_ACCOUNT",
  STORE_DEPOSIT_OPTION = "STORE_DEPOSIT_OPTION",
  SHIPPING_RECIPIENT = "SHIPPING_RECIPIENT",
  SHIPPING_RECIPIENT_HISTORY = "SHIPPING_RECIPIENT_HISTORY",
  PAYROLL_VOUCHER = "PAYROLL_VOUCHER",
  PAYROLL_VOUCHER_CYCLE = "PAYROLL_VOUCHER_CYCLE",
  DASHBOARD_CYCLE = "DASHBOARD_CYCLE",
  DASHBOARD_SUMMARY = "DASHBOARD_SUMMARY",
  DASHBOARD_PENDING = "DASHBOARD_PENDING",
  SHIPPING_HISTORY = "SHIPPING_HISTORY",
  AUDIT_TRAIL = "AUDIT_TRAIL",
  REGIONAL_SUBSTITUTION = "REGIONAL_SUBSTITUTION",
  PRICE_MARKDOWN_VERBA = "PRICE_MARKDOWN_VERBA",
  PRICE_MARKDOWN_OVERVIEW = "PRICE_MARKDOWN_OVERVIEW",
  PRICE_MARKDOWN_SELECAO = "PRICE_MARKDOWN_SELECAO",
  PRICE_MARKDOWN_DRILL = "PRICE_MARKDOWN_DRILL",
  PRICE_MARKDOWN_VERBA_SUMMARY = "PRICE_MARKDOWN_VERBA_SUMMARY",
  PRICE_MARKDOWN_AUDIT = "PRICE_MARKDOWN_AUDIT",
  PRICE_MARKDOWN_INDICADORES = "PRICE_MARKDOWN_INDICADORES",
  PRICE_MARKDOWN_ITEM_HISTORY = "PRICE_MARKDOWN_ITEM_HISTORY",
  PRICE_MARKDOWN_CARTA = "PRICE_MARKDOWN_CARTA",
  PRICE_REMARK_PARAMETERS = "PRICE_REMARK_PARAMETERS",
  PRICE_REMARK_REASONS = "PRICE_REMARK_REASONS",
  PRICE_REMARK_PRODUCTIVITY = "PRICE_REMARK_PRODUCTIVITY",
  PRICE_REMARK_JUSTIFICATIONS = "PRICE_REMARK_JUSTIFICATIONS",
  PRICE_REMARK_LABEL_AUDIT = "PRICE_REMARK_LABEL_AUDIT",
  PRICE_REMARK_PENDING = "PRICE_REMARK_PENDING",
  CONCILIATION_HISTORY = "CONCILIATION_HISTORY",
}
        